import React from 'react';
import {Helmet} from 'react-helmet';
import {useLocation} from 'react-router-dom';
import {useEnvironment} from './Environment';
import {useEnableAppsFlyerBanner} from './FeatureFlags/FeatureFlags';

// https://support.appsflyer.com/hc/en-us/articles/4410472474001#appsflyer-web-sdk-for-smart-banners-only

// Paths we want to show the banner on. Will also match any nested path
// so /orders and /orders/1234 are considered allowed
const ALLOWED_PATHS = ['/orders', '/settings'];

const isMatchedPath = (pathname: string) =>
  !!ALLOWED_PATHS.find((path: string) => pathname.includes(path));

const AppsFlyer = () => {
  const {appsFlyerWebKey, nonce} = useEnvironment();
  const {enabled} = useEnableAppsFlyerBanner();
  const location = useLocation();

  const showAppsFlyer = enabled && !!appsFlyerWebKey && isMatchedPath(location.pathname);

  return showAppsFlyer ? (
    <Helmet>
      <script nonce={nonce}>
        {`!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
        (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
        t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
        o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
        p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${appsFlyerWebKey}"}});
        AF('banners', 'showBanner', { bannerZIndex: 1000, additionalParams: { p1: "v1", p2: "v2"}});`}
      </script>
    </Helmet>
  ) : null;
};

export default AppsFlyer;
